// extracted by mini-css-extract-plugin
export default {"alertContainer":"AlertComponent_alertContainer__oDajI","icon":"AlertComponent_icon__MpVM7","message":"AlertComponent_message__9HgGc","closeIcon":"AlertComponent_closeIcon__elr7t"};